import {FIG_LAYERS_DATA_TYPES, FIG_PARSED_FIELD_TYPES} from "@/includes/fig-parser/constants";

export const recursiveWalker = (nodes, callback) => {
  if (!nodes) {
    return undefined;
  }
  nodes.forEach(node => {
    callback(node)
    if (node.children) {
      recursiveWalker(node.children, callback)
    }
  })
}

export const extractLayersFromTree = tree => {
  const layers = []

  recursiveWalker(tree, node => {
    if (!FIG_LAYERS_DATA_TYPES.includes(node.type)) {
      return;
    }

    layers.push(node)
  })

  return layers
}

/**
 * @param tree
 * @returns {FigmaTemplate[]}
 */
export const extractTemplatesFromTree = tree => {
  const templates = []
  
  recursiveWalker(tree, node => {
    if (node.type !== FIG_PARSED_FIELD_TYPES.CANVAS) {
      return;
    }

    templates.push(...node.children)
  });
  
  return templates;
}

export const recursiveFind = (nodes, callback) => {
  for (const node of nodes) {
    if (callback(node)) {
      return node;
    }
    if (node.children) {
      const found = recursiveFind(node.children, callback)
      if (found) {
        return found
      }
    }
  }

  return undefined
}
